export default __webpack_public_path__ + "static/media/point-watch.af932d80.png";